import styled, { css } from 'styled-components'
import { Image } from '@/ui'

export const CropWrapper = styled.div`
  ${({ theme }) => css`
    .ReactCrop__image {
      max-height: 80vh;
    }
    @media only screen and (max-width: ${theme.breakpoints.mobile}px) {
      .ReactCrop__drag-handle:not(.ord-se)::after {
        content: none !important;
      }

      .ReactCrop__drag-handle::after {
        height: 34px !important;
        width: 34px !important;
        right: 4px !important;
        bottom: 4px !important;
      }
    }
  `}
`

export const Wrapper = styled.div`
  width: 500px;
  display: grid;
  grid-template-columns: auto auto;
`

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    padding-right: 32px;
    border-right: ${({ theme }) => `1px solid ${theme.colors.darkGrey}`};

    ${theme.mediaQueries.mobile} {
      display: none;
    }
  `}
`

export const PreviewImage = styled(Image)`
  border-radius: 3px;
  height: auto;
  width: 217px;
  object-fit: contain;
`

export const ButtonsWrapper = styled.div`
  padding-left: 32px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
`
